// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d7446e4a","991":"c35e7e58"}[chunkId] + ".chunk.js";
};